import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axios from 'utils/axios';
import AxiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

export const getActivites = createAsyncThunk('GET ACTIVITIES', async (data, thunkAPI) => {
  let sorting = data.sorting === 'ascend' ? 'asc' : 'desc';

  let query = `?page=${data.page}&page_size=${data.pageSize}&limit=${data.limit}&text=${data.text}&booking_status=${data.bookingStatus}&currency=${data.currency}&payment_gateway=${data.paymentGateway}&payment_type=${data.paymentMethodTypes}&booking_start_date=${data.startDate}&booking_end_date=${data.endDate}&user_type=${data.userType}&sorting=${sorting}&sorting_field=${data.sortingField}&travel_start_date=${data.travelStartDate}&travel_end_date=${data.travelEndDate}&agency_name=${data.agencyName}&cogs=${data.cogs}&cogs_paid_date=${data.cogsPaidDate}&agency_commission_paid=${data.agencyCommissionPaid}&agency_commission_paid_date=${data.agencyCommissionPaidDate}&non_login=${data.isNonLogin}&agency_id=${data?.agencyId || ''}`;

  const response = await AxiosAdmin.get(`${URL.ACTIVITY_V2}${query}`, thunkAPI);
  return response.data;
});

export const getActivityDetails = createAsyncThunk('GET ACTIVITY DETAILS', async (data, thunkAPI) => {
  const response = await AxiosAdmin.get(
    `${URL.ACTIVITY_V2}?id=${data.referenceNumber}&page_size=100&limit=100&page=1`,
    thunkAPI
  );
  return response.data;
});

export const resendEmailConfirmation = createAsyncThunk(
  'RESEND_ACTIVITY_EMAIL_CONFIRMATION',
  async ({ requestData, v2Version }, thunkAPI) => {
    if (v2Version) {
      const response = await AxiosAdmin.post(URL.ACTIVITY_NOTIFY_EMAIL_V2, requestData, thunkAPI);
      return response.data;
    } else {
      const response = await axios.post(URL.RESEND_ACTIVITY_CONFIRMATION_EMAIL, requestData, thunkAPI);
      return response.data;
    }
  }
);

export const updateActivityRemark = createAsyncThunk('UPDATE_ACTIVITY_REMARKS', async (data, thunkAPI) => {
  let requestData = {
    remark_id: data?.remark_id || '',
    remark: data?.remark,
  };
  const response = await AxiosAdmin.put(`${URL.ACTIVITY_UPDATE_V2}?id=${data.referenceNumber}`, requestData, thunkAPI);
  return response.data;
});

export const updateActivityBooking = createAsyncThunk('UPDATE_ACTIVITY_BOOKING', async (data, thunkAPI) => {
  const response = await AxiosAdmin.put(`${URL.ACTIVITY_UPDATE_V2}?id=${data.referenceNumber}`, data, thunkAPI);
  return response.data;
});

const initialState = {
  isLoading: false,
  activityData: null,
  activityDetails: null,
};

export const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {},
  extraReducers: {
    [getActivites.pending]: (state) => {
      state.isLoading = true;
    },
    [getActivites.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.activityData = action.payload.data;
    },
    [getActivites.rejected]: (state, action) => {
      state.isLoading = false;
      state.activityData = null;
      toast.error(action?.payload?.message);
    },

    [updateActivityRemark.pending]: (state) => {
      state.isLoading = true;
    },
    [updateActivityRemark.fulfilled]: (state) => {
      state.isLoading = false;
      toast.success('Remarks updated successfully');
    },
    [updateActivityRemark.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating remarks');
    },

    [getActivityDetails.pending]: (state) => {
      state.isLoading = true;
      state.activityDetails = null;
    },
    [getActivityDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.activityDetails = action.payload.data;
    },
    [getActivityDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.activityDetails = null;
      toast.error(action?.payload?.message);
    },

    [resendEmailConfirmation.pending]: (state) => {
      state.isLoading = true;
    },
    [resendEmailConfirmation.fulfilled]: (state) => {
      state.isLoading = false;
      toast.success('Email confirmation resent successfully');
    },
    [resendEmailConfirmation.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error resending email confirmation');
    },

    [updateActivityBooking.pending]: (state) => {
      state.isLoading = true;
    },
    [updateActivityBooking.fulfilled]: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload?.message);
    },
    [updateActivityBooking.rejected]: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.message || 'Error updating booking data');
    },
  },
});

export default activitySlice.reducer;
